import React, { useEffect, useState } from 'react';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import {
  useNoteListDispatchContext,
  useNoteListStateContext,
  initializeNoteListCollection,
} from 'Components/AdvisorApp/Viewport/MissionControl/Page/Versions/Default/Tabs/AllNotes/AllNotes/NoteListContext';
import Typography from '@material-ui/core/Typography';
import { useNoteContext } from 'Context/NoteContext';
import Note from './Note';
import { groupResourcesByType } from './util';

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 7,
    padding: theme.spacing(2, 1),
    overflowY: 'auto',
  },
  noteList: {
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    // flex: 1,
    width: '100%',
  },
  note: {
    padding: theme.spacing(0, 0),
  },
  noteSubject: {},
  noteEditor: {},
  hidden: {
    display: 'none',
  },
  hovered: {
    borderWidth: theme.spacing(0.25),
    borderStyle: 'solid',
    borderColor: theme.palette.facet.accentBlue,
    borderRadius: theme.spacing(1),
    margin: theme.spacing(-0.25, -0.25),
  },
  clickToEdit: {
    color: 'white',
    backgroundColor: theme.palette.facet.accentBlue,
    display: 'block',
    textAlign: 'center',
  },
  clickToEditHidden: {
    visibility: 'hidden',
  },
});

const CombinedNotes = ({
  classes, setSelectedNote, selectedNote, ...rest
}) => {
  const { resources, collection } = useNoteListStateContext();
  const listDispatch = useNoteListDispatchContext();
  const [editNote, setEditNote] = useState('');
  const { noteResourceObject } = useNoteContext();

  const resourcesGroupedByType = groupResourcesByType(resources);

  useEffect(() => {
    // eslint-disable-next-line eqeqeq
    if (resourcesGroupedByType.length === 0 && noteResourceObject.noteResource?.id() != undefined && collection) {
      initializeNoteListCollection(listDispatch, collection.link('self').url());
    }
  }, [noteResourceObject.noteResource]);

  if (resourcesGroupedByType.length === 0) {
    return (
      <div className={classes.root}>
        <div className={classes.noteList}>
          <Typography variant="h3">No Notes Found</Typography>
        </div>
      </div>
    );
  }

  const noteResources = [];
  resourcesGroupedByType.forEach(group => {
    group.notes.forEach(resource => {
      if (resource.id() === noteResourceObject.noteResource?.id()) {
        return;
      }
      noteResources.push(resource);
    });
  });

  const setSelectedNoteFunc = (id, waypointType, noteSubject, waypointDetails) => {
    if (waypointDetails.previousPosition === undefined) {
      setSelectedNote(id);
    } else if (waypointType === 'enter' && waypointDetails.previousPosition === 'above') {
      setSelectedNote(id);
    } else if (waypointType === 'leave' && waypointDetails.currentPosition === 'above') {
      const index = noteResources.findIndex((resource) => `Note-${resource.id()}` === id);
      if (index < noteResources.length - 1) {
        setSelectedNote(`Note-${noteResources[index + 1].id()}`);
      }
    }
  };

  const notes = noteResources.map(resource => <Note key={`note-${resource.id()}`} noteResource={resource} setSelectedNote={setSelectedNoteFunc} editNote={editNote} setEditNote={setEditNote} {...rest} />);

  return (
    <div className={classes.root}>
      <div className={classes.noteList}>
        {notes}
      </div>
    </div>
  );
};

CombinedNotes.propTypes = {
  classes: PropTypes.object.isRequired,
  setSelectedNote: PropTypes.func.isRequired,
  selectedNote: PropTypes.string.isRequired,
};

export default withStyles(styles)(CombinedNotes);
